/**
 * A failed answer from the console's own API, with the HTTP status it came with.
 *
 * `api.ts` used to throw a bare `Error` carrying only the worker's `error` text, so a
 * screen could not tell a 403 from a 500 from a dropped connection — and Teams, Access
 * and Audit said «visible to admins only» on every one of them, while the Overview said
 * «the console database is unreachable» on a 403 (the TikTok console's map of the SPA's
 * second wave, audits/2026-10-20/SUMMARY.md at 09:59–10:00Z). The status rides on the error;
 * what a screen SAYS about it is `lib/read-failure.ts`.
 *
 * Its own module, with no imports, so that the runner can load it: `api.ts` reads
 * `import.meta.env` through `config.ts` and cannot be imported by a test.
 */
export class ApiError extends Error {
	/** The HTTP status the console answered with. */
	readonly status: number;

	constructor(message: string, status: number) {
		super(message);
		this.name = "ApiError";
		this.status = status;
	}
}

/**
 * The status of a failed read, or `null` when there was no answer at all — `fetch`
 * itself threw (network, DNS, the console unreachable), or the failure is not the
 * console's API.
 */
export function statusOf(e: unknown): number | null {
	return e instanceof ApiError ? e.status : null;
}
